import {
  CREATE_SUPPORT_TICKET,
  CREATE_SUPPORT_TICKET_SUCCESS,
  CREATE_SUPPORT_TICKET_FAILURE,
  GET_SUPPORT_TICKETS,
  GET_SUPPORT_TICKETS_SUCCESS,
  GET_SUPPORT_TICKETS_FAILURE,
} from "./actionTypes";

export const createSupportTicket = (payload) => ({
  type: CREATE_SUPPORT_TICKET,
  payload,
});

export const createSupportTicketSuccess = (payload) => ({
  type: CREATE_SUPPORT_TICKET_SUCCESS,
  payload,
});

export const createSupportTicketFailure = () => ({
  type: CREATE_SUPPORT_TICKET_FAILURE,
});

export const getSupportTickets = (payload) => ({
  type: GET_SUPPORT_TICKETS,
  payload,
});

export const getSupportTicketsSuccess = (payload) => ({
  type: GET_SUPPORT_TICKETS_SUCCESS,
  payload,
});

export const getSupportTicketsFailure = () => ({
  type: GET_SUPPORT_TICKETS_FAILURE,
});